<em
  [class]="this.class"
  [style.font-size]="size || defaultSize"
  [style.color]="color"
  [style.justify-content]="align"
></em>